import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-importar-detalles-servicio-propiedad',
  templateUrl: './btn-importar-detalles-servicio-propiedad.component.html',
  styleUrls: ['./btn-importar-detalles-servicio-propiedad.component.css']
})
export class BtnImportarDetallesServicioPropiedadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
